import { API_URLS } from "../../../config/apiUrls";
import axiosInstance from "../../../config/axios";

export const VariantSpecificationGetFn = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.product_specification, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const variantListByProductIdFn = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.variantListCopy, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const VariantSpecificationPostFns = (reqBody) => {
  try {
    const response = axiosInstance.post(
      API_URLS.product_specification,
      reqBody
    );
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteTypeOne = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.product_specification, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const VariantSpecificationUpdateFns = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.product_specification, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
